// Etiqueta del badge por estado_visual
export const BADGE_LABEL = {
  "GESTIÓN INICIADA":          "Iniciada",
  "EN PROCESO":                "En proceso",
  "GESTIÓN EN SEGUIMIENTO":    "En seguimiento",
  "APROBADO":                  "Aprobada",
  "RECHAZADO POR FINANCIADOR": "Rechazada",
};

// Mensaje por estado_visual.
// Puede ser string (un párrafo) o array de strings (varios párrafos).
// El componente ModalMensajes renderiza cada elemento como un <p> separado.
export const MENSAJE_ESTADO = {
  "GESTIÓN INICIADA":
    "Le informamos que hemos iniciado la gestión de autorización de su procedimiento ante su financiador. A partir de este momento nuestro equipo realizará el seguimiento activo para obtener respuesta a la brevedad.",
  "EN PROCESO":
    "Le informamos que la gestión de su procedimiento se encuentra en análisis por parte de su financiador. Estamos atentos a su evolución para agilizar la respuesta.",
  "GESTIÓN EN SEGUIMIENTO": [
    "Su trámite continúa en proceso. Hemos reforzado el reclamo ante su financiador para agilizar la respuesta. Le informaremos ante cualquier novedad.",
    "Por favor, tenga en cuenta que el financiador dispone de un plazo de respuesta hasta 24 horas antes del turno quirúrgico.",
  ],
  "APROBADO":
    "Le informamos que su procedimiento fue autorizado por su financiador. Dentro de las 24 horas hábiles previas a su intervención, nuestro equipo se contactará con usted para brindarle las indicaciones finales y coordinar los detalles del ingreso.",
  "RECHAZADO POR FINANCIADOR":
    "Su cobertura médica no ha emitido la autorización correspondiente para la prestación solicitada. Para conocer los motivos, le sugerimos comunicarse con su financiador.",
};
